import React from 'react'
import './sidebar.scss'

const MoonIcon = () => {
    return (

        <svg className='sun-moon' id="moon-icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 119.3 138.76">

            <path d="M119.3,117.66c-5.84,6.03-12.87,11.08-20.97,14.79-34.86,15.96-76.06.63-92.01-34.23C-9.64,63.36,5.68,22.16,40.54,6.21,48.63,2.51,57.05.49,65.42,0c-28.24,16.76-39.84,52.47-25.87,83.01,13.98,30.53,48.6,45.08,79.75,34.65Z" />
        </svg>
    )
}

export default MoonIcon
